/**
 * Auth options
 */
export interface IAuthOptions {
    tokenKey: string;
    registerPath: string;
    loginPath: string;
    checkPath: string;
    logoutPath: string;
    appEntry: string;
}

/**
 * Default auth options
 */
export const DEFAULT_AUTH_OPTIONS: IAuthOptions = {
    tokenKey: '__token__',
    registerPath: '/api/register',
    loginPath: '/api/authenticate',
    checkPath: '/api/check-auth',
    logoutPath: '/logout',
    appEntry: '/platform',
};
